import React from 'react';
import { Card, CardMedia, CardContent, Typography, Grid, Container, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import meeshoImg from '../assets/Meesho_logo.png';
import flipkartImg from '../assets/flipkart_logo.png';
import amazonImg from '../assets/amazon.webp';
import shopsyImg from '../assets/Shopsy_logo.jpeg';
import myntraImg from '../assets/myntra.jpg';
import Navbar from './Navbar';
import HeroSection from './HeroSection';
import Footer from './Footer';
import instagramImg from '../assets/insta.jpeg';
import AboutReviewPlatform from './AboutReviewPlatform';
import ProductCarousel from './ProductCarousel';

const shops = [
  { name: 'Meesho', image: meeshoImg },
  { name: 'Flipkart', image: flipkartImg },
  { name: 'Amazon', image: amazonImg },
  { name: 'Instagram', image: instagramImg },
  { name: 'Myntra', image: myntraImg },
];

const ShopCards = () => {
  const navigate = useNavigate();


  return (
    <>
    {/* <Navbar /> */}
    <HeroSection />
    <ProductCarousel />
        <AboutReviewPlatform />
    {/* <Container maxWidth="xl" sx={{backgroundColor: '#fff',}} >
  <Grid container spacing={{ xs: 2, sm: 4 }} justifyContent="center">

        {shops.map((shop, index) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
          <Card
  sx={{
     mb: 5,
    height: { xs: 25, sm: 180, md: 220 },
    width: { xs: 25, sm: 180, md: 220 },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    p: 1,
    borderRadius: 3,
    boxShadow: 4,
    cursor: 'pointer',
    transition: 'all 0.3s ease-in-out',
    mx: 'auto',
    '&:hover': {
      boxShadow: 8,
      transform: 'translateY(-5px)',
    },
  }}
>
  <Box
    component="img"
    src={shop.image}
    alt={shop.name}
    sx={{
      height: { xs: 40, sm: 80, md: 120 },
      width: '100%',
      objectFit: 'contain',
      mb: 1,
    }}
  />
  <CardContent sx={{ textAlign: 'center', p: 0 }}>
    <Typography
      variant="caption"
      sx={{
        fontWeight: 600,
        fontSize: { xs: '0.7rem', sm: '0.9rem', md: '1rem' },
      }}
    >
      {shop.name}
    </Typography>
  </CardContent>
</Card>

          </Grid>
        ))}
      </Grid>
    </Container> */}
    <Footer />
    </>
  );
};

export default ShopCards;
